import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "tips" }
const _hoisted_3 = { style: {"margin-top":"10px"} }
const _hoisted_4 = { class: "sku" }
const _hoisted_5 = { class: "flex" }
const _hoisted_6 = { class: "productTitle" }
const _hoisted_7 = { style: {"margin-top":"10px"} }
const _hoisted_8 = { class: "total" }
const _hoisted_9 = { class: "flex-end footer" }

import { ttsSetSkuStock } from '@/apis/api'
import { t } from '@/plugins/i18n'
import { ref } from 'vue'
import { ElMessage } from 'element-plus'

export default /*#__PURE__*/_defineComponent({
  emits: ['success'],
  setup(__props, { expose, emit: emits }) {

const total = ref(0)
const visible = ref(false)
const shopInfo = ref<any>({})

const updateTiktok = async () => {
  const res = await ttsSetSkuStock({ thirdSkuCode: shopInfo.value.thirdSkuCode, stockNum: total.value })
  visible.value = false
  ElMessage.success(t('在庫の反映が完了しました'))
  emits('success', shopInfo.value)
}

expose({
  show: (row: any) => {
    console.log(row, 'row');
    total.value = row.thirdStock
    shopInfo.value = row
    visible.value = true
  }
})


return (_ctx: any,_cache: any) => {
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_space = _resolveComponent("el-space")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    "append-to-body": "",
    "custom-class": "UpdateTiktokNum",
    modelValue: visible.value,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((visible).value = $event)),
    width: "500px"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, _toDisplayString(_unref(t)('更新tiktok库存')), 1),
      _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(t)('将商品库存更新到tiktok商品“总在库数”上')), 1),
      _createElementVNode("div", _hoisted_3, "SKU：" + _toDisplayString(shopInfo.value?.thirdSkuCode), 1),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_el_image, {
            style: {"width":"100px","height":"100px","flex-shrink":"0","margin-right":"10px"},
            src: shopInfo.value?.thirdItemImage
          }, null, 8, ["src"]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", null, _toDisplayString(shopInfo.value?.thirdItemName), 1),
            _createElementVNode("div", _hoisted_7, _toDisplayString(shopInfo.value?.thirdItemAttribute), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createTextVNode(_toDisplayString(_unref(t)('总在库数')) + ": ", 1),
          _createVNode(_component_el_input_number, {
            controls: false,
            min: 0,
            max: 99999,
            precision: 0,
            modelValue: total.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((total).value = $event))
          }, null, 8, ["modelValue"])
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_el_space, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (visible.value = false))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('取消')), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: updateTiktok
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('确认更新')), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})